import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Seller } from '../../models';
import { SellerService } from '../../services/seller.service';
import { LoadSeller, LoadSellerFailure, LoadSellerSuccess, SellerActionTypes } from './seller.actions';

@Injectable({
  providedIn: 'root',
})
export class SellerEffects {
  @Effect()
  getSeller$: Observable<Action> = this.actions$.pipe(
    ofType(SellerActionTypes.LOAD_SELLER),
    switchMap((action: LoadSeller) =>
      this.sellerService.getSeller(action?.payload?.id).pipe(
        map((seller: Seller) => new LoadSellerSuccess({ seller })),
        catchError((error) => of(new LoadSellerFailure({ error })))
      )
    )
  );

  constructor(private actions$: Actions, private sellerService: SellerService) {}
}
